<template>
  <header class='font-sans tracking-wide relative z-50'>
    <div
      class='flex flex-wrap items-center justify-between gap-4 px-6 md:px-10 py-8 min-h-[70px]'
    >
    <div class="flex items-center ">
      <div class="logo-container flex items-center">
        <img src="/logo-terreiro-vo-rita.png" alt="logo" class='w-28' />
        <strong class="text-lg mx-4 text-center">
          Terreiro de Umbanda<br>Vó Rita das Almas
        </strong>
      </div>
  
      <div
        ref="collapseMenu"
        id="collapseMenu"
        :style="`display:${isMnMbOpened ? 'block' : 'none'}`"
        class='max-lg:hidden lg:!block max-lg:before:fixed max-lg:before:bg-black max-lg:before:opacity-50 max-lg:before:inset-0 max-lg:before:z-50 ml-4'
      >
        <button id="toggleClose" class='lg:hidden fixed top-5 right-3 z-[100] rounded-full bg-white p-3' @click="toggleMenuMb">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 fill-black" viewBox="0 0 320.591 320.591">
            <path
              d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
              data-original="#000000"></path>
            <path
              d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
              data-original="#000000"></path>
          </svg>
        </button>
  
        <ul
          class='lg:flex lg:gap-x-2 max-lg:space-y-3 max-lg:fixed max-lg:bg-white max-lg:w-1/2 max-lg:min-w-[300px] max-lg:top-0 max-lg:left-0 max-lg:p-6 max-lg:h-full max-lg:shadow-md max-lg:overflow-auto z-50'>
          <li
            v-for="(link, idx) in links"
            :key="idx"
            @click="() => link.click && link.click()"
            :class="{'active': (<string>route.name || '')?.startsWith(link?.routeName || '')}"
            class='max-lg:border-b max-lg:py-3 mx-3'
          >
            <nuxt-link
              @click="toggleMenuMb" 
              :href='link.href'
              class='block font-bold text-[15px]'
            >
              {{ link.name }}
            </nuxt-link>
          </li>
        </ul>
      </div>
    </div>
  
      <div class='flex max-lg:ml-auto'>
        <button id="toggleOpen" class='lg:hidden' @click="toggleMenuMb">
          <svg class="w-7 h-7" fill="#000" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clip-rule="evenodd"></path>
          </svg>
        </button>
      </div>
    </div>
  </header>
</template>
<script lang="ts" setup>
// -------------------------------------------
// Hooks
// -------------------------------------------
const { t } = useI18n();
const route = useRoute();
const localePath = useLocalePath();
const isMnMbOpened = useState('isMnMbOpened', () => false);
const collapseMenu = ref<HTMLElement | null>(null);

// -------------------------------------------
// State
// -------------------------------------------
const links = computed(() => [
  { name: t('HOME'), href: '/', routeName: 'index' },
  { name: t('EVENTS'), href: '/events', routeName: 'events' },
  { name: t('BLOG'), href: '/blog', routeName: 'blog' },
  { name: t('ABOUT_US'), href: '/about', routeName: 'about' },
  { name: t('WHO_IS_VO_RITA'), href: '#', click: openVoRitaModal, routeName: 'vo-rita' },
  { name: t('FAQS'), href: '/faqs', routeName: 'faqs' },
  { name: t('HEADQUARTERS_FOUNDERS'), href: '#', click: openHeadquartersFoundersModal, routeName: 'headquarters-founders' },
]);

function toggleMenuMb() {
  isMnMbOpened.value = !isMnMbOpened.value
}

function openVoRitaModal() {
  document.body.classList.add('show-vo-rita-modal');
}

function openHeadquartersFoundersModal() {
  document.body.classList.add('show-headquarters-founders-modal');
}

</script>
<style lang="scss" scoped>
ul li {
  position: relative;
  // color: var(--theme);

  a::before {
    opacity: 0;
    visibility: hidden;
    border-radius: 4px;
    position: absolute;
    background-color: var(--theme);
    content: '';
    bottom: -4px;
    height: 2px;
    width: 0;
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    color: var(--theme-dark);

    a::before {
      width: 100%;
      opacity: 1;
      visibility: visible;
    }
  }

  &.active {
    a::before {
      width: 100%;
      opacity: 1;
      visibility: visible;
    }
  }
}

@media (screen(xl)) {
  .light-theme {
    ul li {
      color: #fff;
  
      &:hover {
        color: #ffffffe1;
      }
  
      a::before {
        background-color: #fff;
      }
    }
  
    svg {
      fill: #fff;
    }
  }
}
</style>